import React from 'react';
import AttendStampForm from 'components/organismos/master/attend/AttentStampForm';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import { useHistory } from 'react-router-dom';

const AttendStampList = () => {
  const history = useHistory();
  const attendFlag = sessionStorage.getItem('attendStampList.attendFlag') || '0';

  if(window.location.pathname === '/' && sessionStorage.getItem('loginUser.site') === '1'){
    history.push('/attendStampList');
  }

  return (
    <SidebarTemplate pageTitle={attendFlag === '0' ? '打刻データ確認' : '勤務組織打刻データ確認'}>
      <AttendStampForm />
    </SidebarTemplate>
  );
};

export default AttendStampList;
